import React from "react";
import { PasswordInput } from "react-admin";
import { useFormState } from "react-final-form";

const RetypePasswordInput = (props: any) => {
  const { values } = useFormState();

  const passwordValidation = (value: any, allValues: any) => {
    if (values.user?.password !== (value === undefined ? undefined : value)) {
      return "Password does not match!";
    }
    return null;
  };

  return (
    <PasswordInput
      label="Retype Password"
      source="user.passwordConfirmation"
      validate={[passwordValidation]}
      {...props}
    />
  );
};

export default RetypePasswordInput;
